import { Timers } from "./reducer";

export enum ActionTypes {
  ADD_TIMER = "ADD_TIMER",
  START_INTERVAL = "START_INTERVAL",
  STOP_INTERVAL = "STOP_INTERVAL",
  CLEAR_TIMERS = "CLEAR_TIMERS",
}

export interface ActionTimerBase {
  readonly type: ActionTypes;
  readonly payload: any;
}

export interface ActionAddTimer extends ActionTimerBase {
  payload: Timers;
}

export interface ActionTimersIntervalStart extends ActionTimerBase {
  payload: Timers;
}

export interface ActionTimersIntervalStop extends ActionTimerBase {
  payload: number;
}

export interface ActionClearTimers extends ActionTimerBase {}
